import store from '@/store';
import base from '@/__vue2stone/service/wasaapi/v1/__base';

export default {
  async show(guidelineVersionId) {
    const params = {
      factory: store.state.app.factory.id,
    };
    const res = await base.show({
      modelName: 'guideline_version',
      modelId: guidelineVersionId,
      params,
    });
    return res;
  },
  async indexAnnounce(guidelineId) {
    const params = {
      factory: store.state.app.factory.id,
    };
    const res = await base.index({
      parentName: 'guideline',
      parentId: guidelineId,
      modelName: 'guideline_version/index/announce',
      params,
    });
    return res;
  },
}